import type { FC, ReactNode } from 'react';
import { Modal } from 'antd';
import type { ModalProps } from 'antd';
import { X } from 'lucide-react';
import { IpcButton, type IpcButtonVariant } from './IpcButton';

type Props = Omit<ModalProps, 'okText' | 'cancelText' | 'okButtonProps' | 'cancelButtonProps'> & {
  okText?: ReactNode;
  cancelText?: ReactNode;
  confirmLoading?: boolean;
  okDisabled?: boolean;
  cancelDisabled?: boolean;
  /** 确认按钮样式，默认 primary；终止等场景可用 destructive */
  okVariant?: IpcButtonVariant;
};

/**
 * IPC modal shell: centered overlay, prototype spacing, link cancel and primary confirm.
 */
export const IpcModal: FC<Props> = ({
  className,
  rootClassName,
  centered = true,
  width = 448,
  okText = '确认',
  cancelText = '取消',
  onOk,
  onCancel,
  confirmLoading,
  okDisabled = false,
  cancelDisabled = false,
  okVariant = 'primary',
  footer,
  children,
  maskClosable = false,
  ...rest
}) => {
  const defaultFooter =
    footer === undefined ? (
      <div className="ipc-modal__footer-actions">
        <IpcButton variant="link" disabled={cancelDisabled} onClick={e => onCancel?.(e)}>
          {cancelText}
        </IpcButton>
        <IpcButton variant={okVariant} loading={confirmLoading} disabled={okDisabled} onClick={e => onOk?.(e)}>
          {okText}
        </IpcButton>
      </div>
    ) : (
      footer
    );

  return (
    <Modal
      {...rest}
      maskClosable={maskClosable}
      rootClassName={['ipc-modal-root', rootClassName].filter(Boolean).join(' ')}
      className={['ipc-modal', className].filter(Boolean).join(' ')}
      centered={centered}
      width={width}
      onOk={onOk}
      onCancel={onCancel}
      footer={defaultFooter}
      closeIcon={<X size={16} />}
      destroyOnHidden
    >
      {children}
    </Modal>
  );
};
